


















import { Component, Vue, Watch} from 'vue-property-decorator';
import { mapState } from 'vuex';
@Component({
})
export default class App extends Vue {

  

}
